<template>
  <!-- 设备日志弹窗 -->
  <a-modal
    :title="`设备日志 - ${equipmentName || ''}`"
    :visible="visible"
    @cancel="handleClose"
    :width="1200"
    :footer="null"
    class="equipment-log-modal"
  >
    <!-- 条件搜索区域 -->
    <div class="table-page-search-wrapper" style="margin-bottom: 16px">
      <a-form layout="inline">
        <a-row :gutter="[16, 8]">
          <!-- 收起状态 -->
          <template v-if="!advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="设备名称">
                <a-input
                  v-model:value="queryParam.equipmentName"
                  placeholder="请输入设备名称"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="时间">
                <a-date-picker
                  v-model:value="queryParam.operationTime"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  placeholder="请选择时间"
                  allow-clear
                  class="no-border-radius-picker"
                />
              </a-form-item>
            </a-col>

            <!-- 收起状态下的按钮 -->
            <a-col :md="8" :sm="24">
              <a-form-item>
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="handleQuery" class="search-button"> 查询 </a-button>
                  <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button reset-button">
                    重置
                  </a-button>
                  <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                    展开
                    <DownOutlined />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>

          <!-- 展开状态 -->
          <template v-else>
            <!-- 第一行 -->
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
              <a-form-item label="设备名称">
                <a-input
                  v-model:value="queryParam.equipmentName"
                  placeholder="请输入设备名称"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
              <a-form-item label="时间">
                <a-date-picker
                  v-model:value="queryParam.operationTime"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  placeholder="请选择时间"
                  allow-clear
                  class="no-border-radius-picker"
                />
              </a-form-item>
            </a-col>
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
              <a-form-item label="事由">
                <a-input
                  v-model:value="queryParam.operationReason"
                  placeholder="请输入事由"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
              <a-form-item label="操作人">
                <a-input
                  v-model:value="queryParam.operationName"
                  placeholder="请输入操作人"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>

            <!-- 第二行：按钮行 -->
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8"></a-col>
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
              <a-form-item>
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="handleQuery" class="search-button"> 查询 </a-button>
                  <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button reset-button">
                    重置
                  </a-button>
                  <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                    收起
                    <UpOutlined />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operations" style="margin-bottom: 16px">
      <a-button
        type="text"
        shape="circle"
        @click="handleRefresh"
        v-hasPermi="refreshPermission"
        class="refresh-icon-button"
      >
        <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
      </a-button>
      <a-button
        @click="handleExport"
        :disabled="!list || list.length === 0 || pagination.total === 0"
        v-hasPermi="exportPermission"
        class="no-border-button export-button"
      >
        <UploadOutlined />导出
      </a-button>
    </div>
    <!-- 数据表格 -->
    <div v-if="list && list.length > 0">
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :loading="loading"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        rowKey="id"
        size="small"
        class="optimized-table"
        @change="handleTableChange"
      >
        <!-- 使用 bodyCell 插槽自定义单元格显示 -->
        <template #bodyCell="{ column, record, index }">
          <!-- 序号列：根据分页计算序号 -->
          <template v-if="column.dataIndex === 'id'">
            <span>
              {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
            </span>
          </template>
          <!-- 设备名称列：显示设备名称，如果记录中没有则使用props传入的设备名称 -->
          <template v-else-if="column.dataIndex === 'equipmentName'">
            <span>
              {{ record.equipmentName || equipmentName || '-' }}
            </span>
          </template>
          <!-- 时间列：格式化显示 -->
          <template v-else-if="column.dataIndex === 'operationTime'">
            <span>
              {{ parseTime(record.operationTime) }}
            </span>
          </template>
          <!-- 备注列：单行显示，最多16个字符，超出省略号，添加 tooltip -->
          <template v-else-if="column.dataIndex === 'operationRemark'">
            <a-tooltip v-if="record.operationRemark" placement="rightBottom">
              <template #title>
                <div class="remark-tooltip-content">
                  <template v-if="splitRemark(record.operationRemark).length > 0">
                    <div
                      v-for="(item, idx) in splitRemark(record.operationRemark)"
                      :key="idx"
                      class="remark-tooltip-item"
                    >
                      {{ item }}
                    </div>
                  </template>
                  <span v-else>{{ record.operationRemark }}</span>
                </div>
              </template>
              <div class="remark-content">
                {{ truncateText(record.operationRemark, 50) }}
              </div>
            </a-tooltip>
            <span v-else>-</span>
          </template>
        </template>
      </a-table>

      <!-- 分页组件 -->
      <div class="pagination-wrapper">
        <div class="pagination-left">
          <span class="pagination-info">
            显示第 {{ (pagination.current - 1) * pagination.pageSize + 1 }} 到第
            {{ Math.min(pagination.current * pagination.pageSize, pagination.total) }} 条数据/共
            {{ pagination.total }} 条
          </span>
          <a-select
            v-model:value="pagination.pageSize"
            style="width: 100px; margin-left: 8px"
            @change="onShowSizeChange(pagination.current, pagination.pageSize)"
            class="no-border-radius-select"
          >
            <a-select-option :value="10">10条/页</a-select-option>
            <a-select-option :value="20">20条/页</a-select-option>
            <a-select-option :value="50">50条/页</a-select-option>
            <a-select-option :value="100">100条/页</a-select-option>
          </a-select>
        </div>
        <div class="pagination-right">
          <a-pagination
            :current="pagination.current"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            :show-total="() => ''"
            @change="changeSize"
          />
          <span class="pagination-jump">
            到第
            <a-input-number
              v-model:value="jumpPage"
              :min="1"
              :max="Math.ceil(pagination.total / pagination.pageSize)"
              style="width: 60px; margin: 0 4px"
              @pressEnter="handleJumpPage"
              class="no-border-radius-input-number"
            />
            页
          </span>
        </div>
      </div>
    </div>
    <!-- 空数据提示 -->
    <a-empty v-else description="暂无设备日志数据" style="padding: 60px 0" />
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 设备日志组件
 * 功能：显示指定设备的操作日志记录
 * - 支持按设备名称、时间、事由、操作人筛选日志
 * - 支持分页查询和刷新
 * - 支持导出日志数据
 * - 通过props接收设备ID和名称
 */
import { SearchOutlined, RedoOutlined, UploadOutlined, UpOutlined, DownOutlined } from '@ant-design/icons-vue'
import { pageEquipmentLog } from '@/api/system/equipmentLog'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'EquipmentLog',
  mixins: [tableMixin],
  components: {
    SearchOutlined,
    RedoOutlined,
    UploadOutlined,
    UpOutlined,
    DownOutlined,
  },
  props: {
    // 弹窗显示/隐藏状态
    visible: {
      type: Boolean,
      default: false,
    },
    // 设备ID（必填）
    equipmentId: {
      type: Number,
      default: null,
    },
    // 设备名称（用于显示在标题中）
    equipmentName: {
      type: String,
      default: '',
    },
    // 权限前缀，用于动态生成权限值
    permissionPrefix: {
      type: String,
      default: 'system:equipmentLog',
    },
  },
  data() {
    return {
      // 日志列表数据
      list: [],
      // 加载状态
      loading: false,
      // 选中的行key数组
      selectedRowKeys: [],
      // 选中的行数据数组
      selectedRows: [],
      // 初始化标志，防止重复请求
      isInitializing: false,
      // 高级搜索 展开/收起
      advanced: false,
      // 查询参数
      queryParam: {
        equipmentName: undefined, // 设备名称
        operationTime: null, // 操作时间
        operationReason: undefined, // 事由
        operationName: undefined, // 操作人
      },
      // 分页配置
      pagination: {
        current: 1, // 当前页码
        pageSize: 10, // 每页条数
        total: 0, // 总条数
      },
      // 跳转页码
      jumpPage: 1,
      // 表格列配置
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          align: 'center',
          width: 80,
        },
        {
          title: '设备名称',
          dataIndex: 'equipmentName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: '时间',
          dataIndex: 'operationTime',
          align: 'center',
          width: 180,
        },
        {
          title: '事由',
          dataIndex: 'operationReason',
          align: 'center',
          ellipsis: true,
        },
        {
          title: '操作人',
          dataIndex: 'operationName',
          align: 'center',
          width: 120,
        },
        {
          title: '备注',
          dataIndex: 'operationRemark',
          align: 'left',
          width: 400,
        },
      ],
    }
  },
  computed: {
    /**
     * 刷新权限
     * 根据权限前缀动态生成刷新权限值
     */
    refreshPermission() {
      return [`${this.permissionPrefix}:refresh`]
    },
    /**
     * 导出权限
     * 根据权限前缀动态生成导出权限值
     */
    exportPermission() {
      return [`${this.permissionPrefix}:export`]
    },
  },
  watch: {
    /**
     * 监听弹窗显示状态
     * 当弹窗打开且设备ID存在时，初始化数据
     */
    visible(newVal) {
      if (newVal && this.equipmentId) {
        this.$nextTick(() => {
          if (!this.isInitializing) {
            this.init()
          }
        })
      } else if (!newVal) {
        // 弹窗关闭时重置初始化标志
        this.isInitializing = false
      }
    },
    /**
     * 监听设备ID变化
     * 当设备ID变化且弹窗打开时，重新初始化数据
     */
    equipmentId(newVal, oldVal) {
      // 只有当设备ID真正变化（从无到有，或从一个值变为另一个值）且弹窗打开时才初始化
      if (newVal && newVal !== oldVal && this.visible) {
        this.$nextTick(() => {
          if (!this.isInitializing) {
            this.init()
          }
        })
      }
    },
  },
  methods: {
    /**
     * 切换高级搜索展开/收起状态
     */
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    /**
     * 初始化数据
     * 重置分页、清空列表、重置查询条件，然后获取日志列表
     */
    init() {
      // 防止重复初始化
      if (this.isInitializing) {
        return
      }
      this.isInitializing = true

      // 重置分页到第一页
      this.pagination.current = 1
      this.pagination.total = 0
      this.jumpPage = 1
      // 清空列表数据
      this.list = []
      // 清空选中状态
      this.selectedRowKeys = []
      this.selectedRows = []
      // 重置查询条件
      this.queryParam = {
        equipmentName: undefined,
        operationTime: null,
        operationReason: undefined,
        operationName: undefined,
      }
      // 获取日志列表
      this.getList().finally(() => {
        // 请求完成后重置标志
        this.isInitializing = false
      })
    },

    /**
     * 获取设备日志列表
     * 根据设备ID和查询条件分页查询日志数据
     * @returns {Promise} 返回请求的 Promise
     */
    getList() {
      // 校验设备ID
      if (!this.equipmentId) {
        this.$message.warning('设备ID不能为空', 3)
        return Promise.resolve()
      }

      // 开始加载
      this.loading = true

      // 构建请求参数
      const params = {
        equipmentId: this.equipmentId, // 设备ID
        equipmentName: this.queryParam.equipmentName, // 设备名称
        pageNum: this.pagination.current, // 当前页码
        pageSize: this.pagination.pageSize, // 每页条数
        operationTime: this.queryParam.operationTime, // 操作时间
        operationReason: this.queryParam.operationReason, // 事由
        operationName: this.queryParam.operationName, // 操作人
      }

      // 移除空值参数，避免传递无效参数
      Object.keys(params).forEach((key) => {
        if (params[key] === undefined || params[key] === null || params[key] === '') {
          delete params[key]
        }
      })

      // 发送请求并返回 Promise
      return pageEquipmentLog(params)
        .then((response) => {
          // 设置列表数据和总数
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
          this.jumpPage = this.pagination.current
          this.loading = false
        })
        .catch(() => {
          // 请求失败，清空数据
          this.loading = false
          this.list = []
          this.pagination.total = 0
        })
    },

    /**
     * 查询操作
     * 重置到第一页并重新获取列表
     */
    handleQuery() {
      this.pagination.current = 1
      this.jumpPage = 1
      this.getList()
    },

    /**
     * 重置查询条件
     * 清空所有查询条件，重置到第一页并重新获取列表
     */
    handleReset() {
      // 重置查询条件
      this.queryParam = {
        equipmentName: undefined,
        operationTime: null,
        operationReason: undefined,
        operationName: undefined,
      }
      // 重置到第一页
      this.pagination.current = 1
      this.jumpPage = 1
      // 重新获取列表
      this.getList()
    },

    /**
     * 刷新列表
     * 重新获取当前条件下的日志列表
     */
    handleRefresh() {
      this.getList()
    },

    /**
     * 导出日志数据
     * 支持导出选中数据或当前查询条件下的全部数据
     * - 如果选中了数据，则只导出选中的数据
     * - 如果没有选中数据，则导出当前查询条件下的全部数据
     */
    handleExport() {
      const that = this
      const hasSelection = that.selectedRowKeys && that.selectedRowKeys.length > 0
      // 确认对话框
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection ? '将导出所选数据' : '将导出当前筛选条件下的全部数据',
        onOk() {
          // 构建导出参数
          const params = {
            equipmentId: that.equipmentId,
            equipmentName: that.queryParam.equipmentName,
            operationTime: that.queryParam.operationTime,
            operationReason: that.queryParam.operationReason,
            operationName: that.queryParam.operationName,
          }
          // 如果选中了数据，则传递equipmentLogIds参数
          if (hasSelection) {
            params.equipmentLogIds = that.selectedRowKeys
          }
          // 移除空值参数
          Object.keys(params).forEach((key) => {
            if (params[key] === undefined || params[key] === null || params[key] === '') {
              delete params[key]
            }
          })
          // 下载文件
          that.download(
            'system/equipment-log/export',
            params,
            `设备日志_${that.equipmentName || ''}_${new Date().getTime()}.xls`
          )
        },
        onCancel() {},
      })
    },

    /**
     * 关闭弹窗
     * 触发close事件，通知父组件关闭弹窗
     */
    handleClose() {
      $emit(this, 'close')
    },

    /**
     * 多选变化处理
     * 更新选中的行key和行数据
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    /**
     * 表格变化处理
     * 现在分页不在表格内部，这里主要用于处理排序
     */
    handleTableChange(pagination, filters, sorter) {
      // 现在分页不在表格内部，这里主要处理排序
      if (sorter && sorter.field) {
        console.log('排序字段:', sorter.field, '排序方向:', sorter.order)
      }
    },

    /**
     * 每页条数变化
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    onShowSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.current = 1
      this.jumpPage = 1
      this.getList()
    },

    /**
     * 分页变化
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    changeSize(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.jumpPage = current
      this.onSelectChange([], [])
      this.getList()
    },

    /**
     * 跳转页码
     */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.pagination.total / this.pagination.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.pagination.current = this.jumpPage
        this.onSelectChange([], [])
        this.getList()
      }
    },

    /**
     * 分割备注信息
     * 将备注信息按分号（；或;）分割成数组，用于多行显示
     * @param {String} remark - 备注信息
     * @returns {Array} 分割后的备注数组
     */
    splitRemark(remark) {
      if (!remark) {
        return []
      }
      // 后端使用 "; " (英文分号+空格) 作为分隔符
      // 同时兼容中文分号（；）和英文分号（;），以及带空格和不带空格的情况
      // 先统一替换为统一的分隔符
      let normalized = remark
        .replace(/；\s*/g, '|||SEPARATOR|||') // 中文分号，可能带空格
        .replace(/;\s*/g, '|||SEPARATOR|||') // 英文分号，可能带空格
      // 按分隔符分割，并去除每项首尾空格，过滤空字符串
      return normalized
        .split('|||SEPARATOR|||')
        .map((item) => item.trim())
        .filter((item) => item && item.length > 0)
    },

    /**
     * 截取文本
     * 如果文本长度超过指定长度，则截取并添加省略号
     * @param {String} text - 要截取的文本
     * @param {Number} maxLength - 最大长度
     * @returns {String} 截取后的文本
     */
    truncateText(text, maxLength) {
      if (!text) {
        return '-'
      }
      if (text.length <= maxLength) {
        return text
      }
      return text.substring(0, maxLength) + '...'
    },
  },
  emits: ['close'],
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 80px;
  text-align: right;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
}

/* 重置按钮样式 */
.reset-button {
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

/* 展开/收起按钮样式 - 去掉背景，文字颜色改为蓝色 */
.toggle-button {
  background: transparent !important;
  border: none !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  background: transparent !important;
  border: none !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.reset-button:hover,
.reset-button:focus {
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

/* 导出按钮样式 */
.export-button {
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.export-button:hover,
.export-button:focus {
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px;
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 分页组件样式 - 参照 ../index.vue 页面 */
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

.remark-content {
  text-align: left;
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Tooltip 样式 */
.remark-tooltip-content {
  max-width: 400px;
  max-height: 300px;
  overflow-y: auto;
  text-align: left;
  /* 隐藏滚动条但保持滚动功能 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

.remark-tooltip-content::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
  width: 0;
  height: 0;
}

.remark-tooltip-item {
  display: block;
  line-height: 1.8;
  margin-bottom: 6px;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}

.remark-tooltip-item:last-child {
  margin-bottom: 0;
}

/* 隐藏 tooltip 内容滚动条 */
:deep(.ant-tooltip-inner) {
  /* 隐藏滚动条但保持滚动功能 */
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE 10+ */
}

:deep(.ant-tooltip-inner)::-webkit-scrollbar {
  display: none !important; /* Chrome/Safari */
  width: 0 !important;
  height: 0 !important;
}
</style>

<style>
/* 全局样式：隐藏 tooltip 内容滚动条 */
.ant-tooltip-inner {
  /* 隐藏滚动条但保持滚动功能 */
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE 10+ */
}

.ant-tooltip-inner::-webkit-scrollbar {
  display: none !important; /* Chrome/Safari */
  width: 0 !important;
  height: 0 !important;
}

/* 分页组件样式 - 参照 ../index.vue 页面 */
.equipment-log-modal .pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.equipment-log-modal .pagination-left {
  display: flex;
  align-items: center;
}

.equipment-log-modal .pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.equipment-log-modal .pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.equipment-log-modal .pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.equipment-log-modal .pagination-wrapper .ant-btn,
.equipment-log-modal .pagination-wrapper .ant-pagination-item,
.equipment-log-modal .pagination-wrapper .ant-pagination-prev,
.equipment-log-modal .pagination-wrapper .ant-pagination-next,
.equipment-log-modal .pagination-wrapper .ant-pagination-prev .ant-pagination-item-link,
.equipment-log-modal .pagination-wrapper .ant-pagination-next .ant-pagination-item-link,
.equipment-log-modal .pagination-wrapper .ant-pagination-prev button,
.equipment-log-modal .pagination-wrapper .ant-pagination-next button {
  border-radius: 4px !important;
}

/* 分页中的输入框圆角为4px - 覆盖 no-border-radius 类 */
.equipment-log-modal .pagination-wrapper .ant-input-number,
.equipment-log-modal .pagination-wrapper .no-border-radius-input-number,
.equipment-log-modal .pagination-wrapper .no-border-radius-input-number .ant-input-number,
.equipment-log-modal .pagination-wrapper .no-border-radius-input-number .ant-input-number-input,
.equipment-log-modal .pagination-wrapper .ant-input-number-input {
  border-radius: 4px !important;
}

/* 分页中的选择框圆角为4px - 覆盖 no-border-radius 类 */
.equipment-log-modal .pagination-wrapper .ant-select-selector,
.equipment-log-modal .pagination-wrapper .no-border-radius-select,
.equipment-log-modal .pagination-wrapper .no-border-radius-select .ant-select-selector,
.equipment-log-modal .pagination-wrapper .ant-select-focused .ant-select-selector,
.equipment-log-modal .pagination-wrapper .no-border-radius-select.ant-select-focused .ant-select-selector,
.equipment-log-modal .pagination-wrapper .no-border-radius-select .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
}

/* 分页选中页数样式 - 蓝色背景白色文字 - 全局样式确保生效 */
.equipment-log-modal .pagination-wrapper .ant-pagination-item-active,
.equipment-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active {
  background: #165dff !important;
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.equipment-log-modal .pagination-wrapper .ant-pagination-item-active a,
.equipment-log-modal .pagination-wrapper .ant-pagination-item-active a:hover,
.equipment-log-modal .pagination-wrapper .ant-pagination-item-active a:focus,
.equipment-log-modal .pagination-wrapper .ant-pagination-item-active a:visited,
.equipment-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active a,
.equipment-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active a:hover,
.equipment-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active a:focus {
  color: #ffffff !important;
}

.equipment-log-modal .pagination-wrapper .ant-pagination-item-active:hover,
.equipment-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:hover {
  background: #165dff !important;
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.equipment-log-modal .pagination-wrapper .ant-pagination-item-active:hover a,
.equipment-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:hover a {
  color: #ffffff !important;
}

.equipment-log-modal .pagination-wrapper .ant-pagination-item-active:focus,
.equipment-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:focus {
  background: #165dff !important;
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.equipment-log-modal .pagination-wrapper .ant-pagination-item-active:focus a,
.equipment-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:focus a {
  color: #ffffff !important;
}
</style>
